import { useGraphqlSdk } from "src/graphql/graphql-client";
import { InternalError, UserError } from "src/shared/models/user-error";
import { isNullOrUndefined } from "src/shared/object-utils";
import { emitter } from "boot/mitt";
import { date } from "quasar";

export async function conversationSnoozeCommand(conversationId: string, remindAt: Date) {
  const sdk = await useGraphqlSdk();

  const res = await sdk
    .ModifyConversationSnooze({
      conversationId: conversationId,
      remindAt: date.formatDate(remindAt, "YYYY-MM-DD HH:mm:ss"),
      remindAtTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    })
    .catch(err => {
      console.warn(err);
      throw new InternalError(err);
    });

  if (
    isNullOrUndefined(res) ||
    isNullOrUndefined(res.modifyConversation) ||
    isNullOrUndefined(res.modifyConversation.conversation)
  ) {
    throw new InternalError(new Error("Conversation not found"));
  }

  if (res.modifyConversation.errors?.length) {
    throw new UserError(res.modifyConversation.errors);
  }

  res.modifyConversation.events?.forEach(i => {
    emitter.emit("conversation-timeline-created", {
      timeline: i,
      scrollTo: true,
    });
  });

  const conversation = res.modifyConversation.conversation;
  emitter.emit("conversation-modified", conversation);
  return conversation;
}
